import { withText } from "./Text";
import { Small } from "./Text.styles";
var SmallText = withText(Small);
SmallText.displayName = "SmallText";
export { SmallText };
